import { render, staticRenderFns } from "./CompareSection.vue?vue&type=template&id=63568330&scoped=true"
import script from "./CompareSection.vue?vue&type=script&lang=js"
export * from "./CompareSection.vue?vue&type=script&lang=js"
import style0 from "./CompareSection.vue?vue&type=style&index=0&id=63568330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63568330",
  null
  
)

export default component.exports